import axios from 'axios';
const CLIENT_ID = import.meta.env.VITE_UNSPLASH_CLIENT_ID;
const UNSPLASH_URL = import.meta.env.VITE_UNSPLASH_URL;

export const fetchPhotos = async ({ 
  query = 'dog', 
  page = 1, 
  perPage = 30, 
  orientation,
  orderBy = 'relevant' 
}) => {
  const timestamp = Date.now();
  try {
    if (orientation) {
      // If orientation is specified, fetch only in that orientation,
      const response = await axios.get(UNSPLASH_URL, {
        params: {
          query,
          page,
          per_page: perPage,
          orientation: 'landscape', //default to landscape
          order_by: orderBy,
          client_id: CLIENT_ID,
          _t: timestamp
        }
      });
      const { data } = response 
      return { [orientation]: data.results, meta: { total: data.total, totalPages: data.total_pages } };
    } else {
      const [landscapeResponse, portraitResponse] = await Promise.all([
        axios.get(UNSPLASH_URL, {
          params: {
            query,
            page,
            per_page: Math.ceil(perPage / 2),
            orientation: 'landscape',
            order_by: orderBy,
            client_id: CLIENT_ID,
            _t: timestamp
          }
        }),
        axios.get(UNSPLASH_URL, {
          params: {
            query,
            page,
            per_page: Math.floor(perPage / 2),
            orientation: 'portrait',
            order_by: orderBy,
            client_id: CLIENT_ID,
            _t: timestamp
          }
        })
      ]);

      return {
        landscape: landscapeResponse.data.results,
        portrait: portraitResponse.data.results
      };
    }
  } catch (error) {
    console.error('Error fetching photos:', error);
    throw error;
  }
};
